module.exports = __webpack_public_path__ + "img/Romania.1a9204ce.gif";